import React, { useCallback, useEffect, useState, useRef } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Icon, Radio, Tooltip, Col, Row, Button, message, Select, Upload } from 'antd'
import styles from './styles.module.scss'
import dayjs from 'dayjs'
import * as apis from '@/apis'
import debounce from 'lodash/debounce';
const { Option } = Select;
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },

};


const InfoDialog = (props) => {
  const { modal, isOpen, form, isEdit, rowItem = {}, tenantId, ...ownProps } = props
  const { getFieldDecorator, validateFields, getFieldValue, setFieldsValue, resetFields } = form;

  const [loading, setLoading] = useState(false)


  const initData = async () => {

  }

  const customRequest = useCallback(file => {
    if (loading) return false

    const formData = new FormData()
    formData.append('file', file)
    // formData.append('type', 'order-images')
    setLoading(true)

    apis.uploadFile(formData).then(response => {
      setFieldsValue({
        avatar: response.url
      });

    }).then(() => {
      message.success('上传成功')
    }).catch(err => {
      message.error(err.message || '图片上传失败')
    }).finally(() => setLoading(false))

    return false
  }, [loading])

  const handleSubmit = debounce(() => {
    validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }
      const queryData = { ...values, tenantId: tenantId }

      if (isEdit) {
        queryData._id = rowItem._id
        apis.editStaff(queryData).then(result => {
          message.success('提交成功')
          props.submit()
          props.submitCallback()
        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
        })
      } else {

        apis.addStaff(queryData)
          .then(result => {
            message.success('添加成功')
            resetFields()
            props.submit()
            props.submitCallback()
          }).catch(err => {
            message.error(err.message || '发生错误')
          }).finally(() => {
          })
      }
    });
  }, 500)

  useEffect(() => {
    initData()
  }, [])

  const uploadButton = (
    <Icon type="plus" style={{ fontSize: 36, color: '#D8D8D8' }} />
  );


  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      width={680}
      visible={isOpen}
      onOk={() => { handleSubmit() }}
      onCancel={props.hide}
    >
      <div>
        <Form
          {...formItemLayout}
        >
          <Row>
            <Col span={12}>
              <Form.Item
                label="姓名"
              >
                {getFieldDecorator('name', {
                  initialValue: rowItem?.realname,
                  rules: [
                    { required: true, message: `请输入姓名`, },
                  ],
                })(
                  <Input max={10} placeholder={`请输入姓名`} />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="手机号"
              >
                {getFieldDecorator('mobile', {
                  initialValue: rowItem.user?.mobile,
                  rules: [
                    { required: true, message: `请输入手机号`, },
                    { pattern: /^[1]([3-9])[0-9]{9}$/, message: '请输入正确手机号' }
                  ],
                })(
                  <Input max={11} placeholder={`请输入手机号`} />
                )}
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                label="密码"
              >
                {getFieldDecorator('password', {
                  initialValue: rowItem.user?.password,
                  rules: [
                    { required: (isEdit ? false : true), message: `请输入密码` },
                  ],
                })(
                  <Input.Password autoComplete="new-password" placeholder={`请输入密码`} />
                )}
              </Form.Item>
            </Col>


            <Col span={12}>
              <Form.Item
                label="是否禁用"
              >
                {getFieldDecorator('isActive', {
                  initialValue: rowItem?.isActive || true,
                  rules: [
                    { required: true, message: `请选择是否禁用` },
                  ],
                })(
                  <Radio.Group>
                    <Radio value={false}>禁用</Radio>
                    <Radio value={true}>正常</Radio>
                  </Radio.Group>
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="头像"
              >
                {getFieldDecorator('avatar', {
                  initialValue: rowItem.user?.avatar,
                  valuePropName: 'fileList',
                  rules: [
                    { required: true, message: `请上传头像` },
                  ],
                })(
                  <Upload
                    listType="picture-card"
                    showUploadList={false}
                    beforeUpload={customRequest}
                    accept=".png, .jpg, .jpeg"
                  >
                    {getFieldValue('avatar') ? (
                      <img
                        src={getFieldValue('avatar')}
                        width="100"
                        alt="avatar"
                      />
                    ) : (
                      uploadButton
                    )}
                  </Upload>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  )
}

export default sagaModal({
  name: 'EMPLOYEE_DIALOG',
})(Form.create()(InfoDialog))
